import { Pipe, PipeTransform } from '@angular/core';
import { FormatHelper } from '../helpers/format-helper';
import { AgentDocument } from '../models/agents/agent-document';

@Pipe({
  name: 'vxFormat'
})
export class VxFormatPipe implements PipeTransform {

  transform(value: string, formatType: string): any {

    const formatter = new FormatHelper();
    const agent = new AgentDocument(value);

    if (formatType === 'cnpj') {
      return formatter.StringToCNPJ(value);
    }

    if (formatType === 'cpf') {
      return formatter.StringToCPF(value);
    }

    if (formatType === 'cellphone') {
      return formatter.StringToCellphone(value);
    }

    if (formatType === 'cpf/cnpj') {
      if (agent.isPerson()) {
        return formatter.StringToCPF(value);
      }
      if (agent.isCompany()) {
        return formatter.StringToCNPJ(value);
      }
    }

    return value;
  }

}
